import { Table } from "react-bootstrap";
import { Button } from "react-bootstrap";
// 부트스트랩

import { useDispatch, useSelector } from "react-redux";
//  useDispatch: store.js 로 요청보내주는 함수. 함수 갖고온 함수 쓰겠다 요청할 때 사용.
//  useSelector:스토어 안 스테이트 갖고오는데 사용.

import { addCount, decreaseCount, deleteItem, sortName } from "./store.js";
// 스토어 안에 함수들 갖고옴.

import { Link } from "react-router-dom";
// 링크

//카트 장바구니 페이지 컴포넌트
function Cart() {
  // 받아서 써야함.
  let state = useSelector((state) => state);

  let dispatch = useDispatch();

// 
  const smallProdcuctStyle = {
    border: '1px solid #ddd',
    width: '60px',
    height: '60px',
    cursor:'pointer'
} ;

// 표 글씨 가운데 정렬
let textverticalAlign ={
   verticalAlign: 'middle', 
   textAlign: 'center' 
} 



  return (
    <div className="container">
      <h5 style={{ padding: "50px" , textAlign:"center"}}>
        {state.user.name}님의 장바구니
      </h5>
      
      <Table>
        <thead>
          <tr style={{borderBottom:"2px solid #000"}}>
            <th style={textverticalAlign}>상품코드</th>
            <th style={textverticalAlign}>상품이미지</th>
            <th style={textverticalAlign}>상품명</th>
            <th style={textverticalAlign}>수량</th>
            <th style={textverticalAlign}>수량관리</th>
          </tr>
        </thead>

        <tbody >
          {state.cart.map((a, i) => (
            <tr key={i} style={{borderBottom:"1px solid rgb(204, 204, 204)"}}>
              <td style={textverticalAlign}>{state.cart[i].code}</td>

              <td style={textverticalAlign}>
                <Link to={`/Product/${state.cart[i].id}`}>
                  <img
                    src={`img/top_seller/${state.cart[i].imgUrl}`}
                    style={smallProdcuctStyle}
                  />
                </Link>
              </td>
              <td style={textverticalAlign}>{state.cart[i].name}</td>
              <td style={textverticalAlign}>{state.cart[i].count}</td>
              <td style={textverticalAlign}>

                {/* 더하기 버튼 */}
                <button type="button"
                  onClick={() => {
                    dispatch(addCount(state.cart[i].code));
                  }}
                  class="btn btn-light btn-outline-dark" 
                  style={{ marginRight: "10px" }}
                >
                  +
                </button>


                {/* 빼기 버튼 */}
                <button type="button"
                  onClick={() => {
                    dispatch(decreaseCount(state.cart[i].code));
                  }}
                  class="btn btn-light btn-outline-dark"
                  style={{ marginRight: "10px" }}
                >
                  -
                </button>

                {/* 삭제버튼 */}
                <button type="button"
                  onClick={() => {
                    dispatch(deleteItem(state.cart[i].code));
                  }}
                  class="btn btn-outline-success"
                >
                  상품삭제
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* 이름순 정렬 */}
      <div className="container" style={{textAlign:"center", padding:"50px"}}>
        <Button
            variant="outline-primary"
            onClick={() => {
            dispatch(sortName(state.cart.Name));
            }}
        >
            이름순정렬
        </Button>

      </div>
      
    </div>
  );
}

export default Cart;
